var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _vm.$route.name === "user-profile" && !_vm.requestData.id
        ? _c("p", { staticClass: "message sign-container" }, [
            _vm._v(
              " Sin firma configurada dentro de la empresa, contáctese con su administrador "
            )
          ])
        : _vm._e()
    ]),
    _vm.showForm && !_vm.exitMessage
      ? _c("div", { staticClass: "sign-container" }, [
          _vm.requestData.id
            ? _c(
                "div",
                { staticClass: "row mb-2" },
                [
                  _c("vs-icon", {
                    staticClass: "col-1",
                    attrs: { icon: "adjust" }
                  }),
                  _c("label", { staticClass: "col-3 text-left" }, [
                    _vm._v("Estado de la firma:")
                  ]),
                  _c("label", { staticClass: "col-2 text-left" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.signData.active ? "Activa" : "Inactiva")
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.$route.name === "users-management" && !_vm.signActive
            ? _c("p", { staticClass: "text-muted" }, [
                _vm._v(
                  " Al activar la firma, esta persona podrá firmar y estampar sus documentos digitalmente en las aprobaciones. ¡Listo, es solo un clic! "
                )
              ])
            : _vm._e(),
          _vm.$route.name !== "user-profile"
            ? _c(
                "div",
                { staticClass: "row d-block text-center" },
                [
                  _vm.signActive
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "secondary" },
                          on: { click: _vm.close }
                        },
                        [_vm._v(" Cerrar ")]
                      )
                    : _c(
                        "b-button",
                        {
                          attrs: { disabled: _vm.loading, variant: "warning" },
                          on: { click: _vm.saveSignature }
                        },
                        [
                          _vm._v(" Activar firma "),
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { small: "", variant: "primary" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.exitMessage && _vm.$route.name === "users-management",
            expression: "exitMessage && $route.name === 'users-management'"
          }
        ],
        staticClass: "text-center alert alert-success p-3",
        attrs: { role: "alert" }
      },
      [
        _vm._v(
          " Identificador de firma grabado exitosamente. Puede cerrar esta ventana. "
        )
      ]
    ),
    _vm.requestData.id && _vm.$route.name === "user-profile"
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("ConfigureStamp", {
              attrs: {
                prefix: "segpres",
                proveedor: "Segpres",
                tipoFirma: "firmaAvanzada",
                user: _vm.user,
                customConfigIds: _vm.stampConfigIds
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.requestData.id && _vm.$route.name !== "user-profile"
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("PreviewStamp", {
              attrs: {
                prefix: "segpres",
                proveedor: "Segpres",
                tipoFirma: "firmaAvanzada",
                user: _vm.user,
                customConfigIds: _vm.stampConfigIds
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }